
const Divider = () => {
  return (
    <div className="max-w-full mx-auto px-4 sm:px-6 lg:px-8 mt-12">
      <div className="w-full h-px bg-gray-300 font-bold"></div>
    </div>
  );
};

export default Divider;